import React from "react";
import { Skeleton } from "app/components/Skeleton";

export const StatusCardSkeleton: React.FC = () => (
  <div className="flex h-[116px] min-w-0 flex-1 flex-col justify-between rounded border border-gray-100 bg-white p-4">
    <Skeleton className="h-4 w-24 rounded" />
    <div className="flex items-center gap-2">
      <Skeleton className="h-[62px] w-[62px] rounded-full shrink-0" />
      <div className="flex flex-col gap-1.5 flex-1">
        <Skeleton className="h-3 w-20 rounded" />
        <Skeleton className="h-3 w-24 rounded" />
        <Skeleton className="h-3 w-16 rounded" />
      </div>
    </div>
  </div>
);

export const TicketStatusWidgetSkeleton: React.FC = () => (
  <div className="flex w-full gap-2.5 pr-2">
    {[...Array(3)].map((_, i) => (
      <StatusCardSkeleton key={i} />
    ))}
  </div>
);
